import PropTypes from 'prop-types'
import React from 'react'
import BaseLibrary from './AppContainers/BaseLibraryContainer'
import { connect } from 'react-redux'

import { fetchMediasActions, clearMediasActions, UploadMediaAction } from '../services/ws/LibraryWS'
import Lib from '../components/Library/Library'
import Constants from '../services/constants/Constants'
import { hasAuth } from '../ContentUtils'

class Library extends BaseLibrary {

  constructor() {
    super()
    this._bind('_handleScroll', '_handleTagsChanged')
    this.state = {
      droppedFiles: [],
      currentCategory: '',
      searchedTags: [],
      searchedTagsString: '',
      iconsTags: [],
      currentAppID: 0,
    }
  }

  UNSAFE_componentWillMount() {
    if (!hasAuth(this.props.user, Constants.AuthConstants.PLAYER_ONLY)) {
      this.props.fetchTags()
    }
    if (this.props.app.id) {
      this.props.fetchMediasTags(this.props.app.id)
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.app.id && this.props.app.id) {
      this.props.fetchMediasTags(this.props.app.id)
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.app && nextProps.app.id) {
      if (nextProps.app.id !== this.state.currentAppID) {
        this.props.clearIcons()
        this.setState({
          currentAppID: nextProps.app.id,
          searchedTags: [],
          searchedTagsString: '',
        })
      }

      let iconsTags = []
      nextProps.iconsTags.forEach((tag, index) => {
        if (tag.keyword) {
          let basicSearch = 'appID'
          let advancedSearch = 'appID' + this.props.app.projectId + '|'
          if (tag.keyword.indexOf(basicSearch) > -1) {
            if (tag.keyword.indexOf(advancedSearch) > -1) {
              let tagToInsert = {
                id: tag.id,
                keyword: tag.keyword.replace(advancedSearch, ''),
              }
              iconsTags.push(tagToInsert)
            }
          } else {
            iconsTags.push(tag)
          }
        }
      })
      this.setState({ iconsTags })
    }
  }

  componentDidMount() {
    if (document.querySelector('#ScrollLibrary')) {
      document.querySelector('#ScrollLibrary').addEventListener('scroll', this._handleScroll)
    }
  }

  componentWillUnmount() {
    this.props.clearMedias()
    if (document.querySelector('#ScrollLibrary')) {
      document.querySelector('#ScrollLibrary').removeEventListener('scroll', this._handleScroll)
    }
  }

  _handleScroll(event) {
    if (event.currentTarget.scrollTop + event.currentTarget.clientHeight >= event.currentTarget.scrollHeight - 120 &&
      this.props.httpStatus !== Constants.ActionsConstants.HTTP.LOADING) {
      if (this.props.libType === 'user') {
        let tags = this._getTagQuery()
        this.props.fetchMedias(this.props.app.id, this.state.libMediaTypes, this.props.mediasSize, tags)
      } else {
        this.props.searchIcons(this.state.searchedTagsString)
      }
    }
  }
  _getTagQuery = () => {
    if (!this.props.selectedMediaTags || !this.props.selectedMediaTags.length) return null
    return this.props.selectedMediaTags.map(st => st.value).join(',')
  }
  _handleTagsChanged(items) {
    this.props.clearIcons()
    let tags = this.state.searchedTags
    tags = []
    let stringToSearch = ''
    items.map((item) => {
      if (item && item.value) {
        tags.push({ id: item.value })
        stringToSearch += item.value + ','
      }
      return null
    })
    if (stringToSearch.charAt(stringToSearch.length - 1) === ',') {
      stringToSearch = stringToSearch.slice(0, -1)
    }
    this.setState({ searchedTags: tags, searchedTagsString: stringToSearch })
    this.props.searchIcons(stringToSearch)
  }

  render() {
    return (
      <Lib
        showFAB
        opened={this.props.isOpen}
        searchMedias={this.props.icons}
        tags={this.state.iconsTags}
        libType={this.props.libType}
        libMediaTypes={this.props.libMediaTypes}
        close={this.props.closeLib}
        libFrom={this.props.openFrom}
        userMedias={this.props.medias}
        totalSize={this.props.totalSize}
        mediasSize={this.props.mediasSize}
        droppedFiles={this.state.droppedFiles}
        currentApp={this.props.app}
        manageFileDrop={this._handleFileDrop}
        manageUploadMedias={this._handleUploadMedias}
        manageDownloadAllMedias={this._handleDownloadAllMedias}
        openedSizeAlert={this.state.openedSizeAlert}
        handleCancelFileDrop={this._handleCancelFileDrop}
        onRemoveFile={this._handleRemoveFile}
        onReplaceFile={this._handleReplace}
        showLoader={this.props.uploadStatus}
        onChangeTags={this._handleTagsChanged}
        searchedTags={this.state.searchedTags}
        app={this.props.app}
        addTagToMedia={this.props.addTagToMedia}
        mediasTags={this.props.mediasTags}
        fetchMedias={this.props.fetchMedias}
        selectedMediaTags={this.props.selectedMediaTags}
        updateSelectedMediaTags={this.props.updateSelectedMediaTags}
        appEditorOpened={this.props.appEditorOpened}
      />
    )
  }

}

Library.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  closeLib: PropTypes.func.isRequired,
  openFrom: PropTypes.string.isRequired,
  libType: PropTypes.string.isRequired,
  libMediaTypes: PropTypes.array,

  app: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  medias: PropTypes.array.isRequired,
  progress: PropTypes.number.isRequired,
  uploadState: PropTypes.string.isRequired,
  icons: PropTypes.array.isRequired,
  uploadStatus: PropTypes.bool.isRequired,
  iconsTags: PropTypes.array.isRequired,

  fetchMedias: PropTypes.func.isRequired,
  fetchIcons: PropTypes.func.isRequired,
  fetchTags: PropTypes.func.isRequired,
  searchIcons: PropTypes.func.isRequired,
  clearIcons: PropTypes.func.isRequired,
  clearMedias: PropTypes.func.isRequired,
  upload: PropTypes.func.isRequired,
  reinitUploader: PropTypes.func.isRequired,
  deleteFile: PropTypes.func.isRequired,
}

const mapStateToProps = ({
  authWS: { user },
  appWS: { app },
  i18n: { locale },
  libraryWS: { medias, progress, uploadState, icons, iconsTags, totalSize, mediasSize, mediasTags, selectedMediaTags },
  http: { upload },
}) => ({
  user,
  app,
  locale,
  medias,
  progress,
  uploadState,
  icons,
  uploadStatus: upload,
  iconsTags,
  totalSize,
  mediasSize,
  mediasTags,
  selectedMediaTags,
})

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  fetchMedias(appid, mediaTypes, sizes, tags) {
    fetchMediasActions(dispatch, appid, null, null, mediaTypes, null, null, sizes, true, tags).fetchMedias()
  },
  updateSelectedMediaTags(tags) {
    fetchMediasActions(dispatch).updateSelectedMediaTags(tags)
  },
  fetchMediasTags(appid, mediaTypes, sizes) {
    fetchMediasActions(dispatch, appid).fetchMediasTags()
  },
  addTagToMedia(appid, id, tags) {
    fetchMediasActions(dispatch, appid).addTagToMedia(id, tags)
  },
  fetchIcons(categoryName) {
    fetchMediasActions(dispatch, null, null, categoryName).fetchIcons()
  },
  fetchTags() {
    fetchMediasActions(dispatch).fetchIconsTags()
  },
  searchIcons(tags) {
    fetchMediasActions(dispatch, null, null, tags).searchIcons()
  },
  clearIcons() {
    fetchMediasActions(dispatch).clearIcons()
  },
  clearMedias() {
    clearMediasActions(dispatch).clearMediasFromStore()
  },
  upload(File, appid) {
    UploadMediaAction(dispatch, File, appid).upload()
  },
  reinitUploader() {
    UploadMediaAction(dispatch).reinit()
  },
  deleteFile(appid, fileid) {
    fetchMediasActions(dispatch, appid, fileid).deleteFile()
  },
  replaceFile(appid, fileid, file) {
    fetchMediasActions(dispatch, appid, fileid, null, null, null, file).replaceFile()
  },
  uploadMedias(appid, file) {
    UploadMediaAction(dispatch, file, appid).uploadMedias()
  }, 
  downloadAllMedias(appid) {
    UploadMediaAction(dispatch, null, appid).downloadAllMedias()
  }, 
})

export default connect(mapStateToProps, mapDispatchToProps)(Library)
